import { t } from "@/i18n-js/instance";
import { usePasswordField } from "@/react/hooks/usePasswordField";
import { PASSWORD_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { PasswordStrengthIndicator } from "@circle-react/components/shared/PasswordField/PasswordStrengthIndicator";
import { PasswordVisibilityToggle } from "@circle-react/components/shared/PasswordField/PasswordVisibilityToggle";
import { Form } from "@circle-react-uikit/Form";

export const SignUpFormPasswordField = () => {
  const {
    isPasswordVisible,
    setIsPasswordVisible,
    isFocused,
    passwordValue,
    passwordFieldError,
    passwordStrength,
    handleBlur,
    handleFocus,
  } = usePasswordField({ fieldName: "user[password]" });

  return (
    <Form.Item
      name="user[password]"
      className="no-padding-top no-margin"
      label={t("authentication_app.signup.form.password")}
      hideDescription
      hideBorder
      rules={{
        required: t(`authentication_app.signup.form.errors.password_required`),
        pattern: {
          value: PASSWORD_REGEX,
          message: t("authentication_app.signup.form.errors.password_invalid"),
        },
      }}
    >
      <div className="relative flex items-center">
        <Form.Input
          type={isPasswordVisible && passwordValue ? "text" : "password"}
          name="user[password]"
          data-testid="password"
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
        <PasswordVisibilityToggle
          passwordValue={passwordValue}
          isPasswordVisible={isPasswordVisible}
          setIsPasswordVisible={setIsPasswordVisible}
        />
      </div>
      {(isFocused || (passwordValue && passwordValue.length > 0)) && (
        <PasswordStrengthIndicator
          passwordStrength={passwordStrength}
          passwordFieldError={passwordFieldError}
          passwordValue={passwordValue}
          hideSuccessMessage
        />
      )}
    </Form.Item>
  );
};
